<template>
    <div class="dashboard-page">
        <!-- 存储空间不足警告 -->
        <div v-if="storageWarning" class="storage-warning">
            <el-alert
                    title="⚠️ 待审核车辆已达上限，请及时处理"
                    type="warning"
                    :closable="false"
                    style="margin-bottom: 20px;"
            >
                <template #default>
                    <span>当前行驶证图片存储即将达到上限，请尽快审核待处理车辆以释放存储空间。</span>
                </template>
            </el-alert>
        </div>

        <div class="card todo-card">
            <div class="card-title">车辆检车待办</div>
            <CommonList
                    selection-type="checkbox"
                    row-key="vehicleId"
                    :has-more-search="false"
                    :auto-load="false"
                    ref="listRef"
                    cellOverflow="ellipsis"
                    @selection-change="handleSelectionChange"
                    @current-row-change="handleCurrentRowChange"
                    @load-start="handleLoadList"
                    @search-click="handleLoadList"
                    @pagination-change="handleLoadList"
                    @reset-click="handleReset"
            >
                <template #search-item-fixed>
                    <div class="common-search-item">
                        <label class="common-search-label80">车牌号：</label>
                        <el-input v-model="searchForm.plateNumber" class="common-input180" placeholder="请输入"></el-input>
                    </div>
                    <div class="common-search-item">
                        <label class="common-search-label80">车主姓名：</label>
                        <el-input v-model="searchForm.userName" class="common-input180" placeholder="请输入"></el-input>
                    </div>
                    <div class="common-search-item">
                        <label class="common-search-label80">检车状态：</label>
                        <el-select v-model="searchForm.checkStatus" class="common-input120" placeholder="请选择" clearable>
                            <el-option label="已预约" value="0"></el-option>
                            <el-option label="已到站" value="1"></el-option>
                            <el-option label="外检中" value="2"></el-option>
                            <el-option label="环检中" value="3"></el-option>
                            <el-option label="安检中" value="4"></el-option>
                            <el-option label="待取证" value="5"></el-option>
                        </el-select>
                    </div>
                </template>

                <template #btn-group>
                </template>

                <template #table-column>
                    <el-table-column prop="userName" label="车主姓名" align="center" width="100">
                        <template #default="scope">{{ maskName(scope.row.userName) }}</template>
                    </el-table-column>
                    <el-table-column prop="plateNumber" label="车牌号" align="center" width="140">
                        <template #default="scope">{{ maskPlate(scope.row.plateNumber) }}</template>
                    </el-table-column>
                    <el-table-column prop="vin" label="车架号" align="center" width="180">
                        <template #default="scope">{{ maskVin(scope.row.vin) }}</template>
                    </el-table-column>
                    <el-table-column prop="userPhone" label="车主手机号" align="center" width="130">
                        <template #default="scope">{{ maskPhone(scope.row.userPhone) }}</template>
                    </el-table-column>
                    <el-table-column prop="appointmentDate" label="预约日期" align="center" width="120">
                        <template #default="scope">
                            {{ scope.row.appointmentDate ? $formatTime(scope.row.appointmentDate, 'YYYY-MM-DD') : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="appointmentTime" label="预约时段" align="center" width="120">
                        <template #default="scope">{{ scope.row.appointmentTime || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="checkStatus" label="检车状态" align="center" width="120">
                        <template #default="scope">
                            <el-tag :type="getCheckStatusTagType(scope.row.checkStatus)">
                                {{ scope.row.checkStatusName || '-' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="windowNo" label="窗口号" align="center" width="100">
                        <template #default="scope">{{ scope.row.windowNo || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="arriveTime" label="到站时间" align="center" width="160">
                        <template #default="scope">
                            {{ scope.row.arriveTime ? $formatTime(scope.row.arriveTime) : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" align="center" min-width="160">
                        <template #default="scope">{{ scope.row.remark || '-' }}</template>
                    </el-table-column>
                </template>
            </CommonList>
        </div>

        <div class="card todo-card">
            <div class="card-title">回收订单待办</div>
            <CommonList
                    selection-type="checkbox"
                    row-key="id"
                    :has-more-search="false"
                    :auto-load="false"
                    ref="orderListRef"
                    cellOverflow="ellipsis"
                    @selection-change="handleSelectionChange"
                    @current-row-change="handleCurrentRowChange"
                    @load-start="handleLoadOrderList"
                    @search-click="handleLoadOrderList"
                    @pagination-change="handleLoadOrderList"
                    @reset-click="handleOrderReset"
            >
                <template #search-item-fixed>
                    <div class="common-search-item">
                        <label class="common-search-label80">订单号：</label>
                        <el-input v-model="orderSearchForm.orderId" class="common-input180" placeholder="请输入"></el-input>
                    </div>
                    <div class="common-search-item">
                        <label class="common-search-label80">订单状态：</label>
                        <el-select
                                v-model="orderSearchForm.orderStatus"
                                class="common-input120"
                                placeholder="请选择"
                                clearable
                        >
                            <el-option
                                    v-for="item in Options.wxOrderStatus"
                                    :key="item.enumCodeName+item.code"
                                    :label="item.enumCodeName"
                                    :value="item.code"
                            ></el-option>
                        </el-select>
                    </div>
                </template>

                <template #btn-group>
                </template>

                <template #table-column>
                    <el-table-column prop="orderId" label="订单号" align="center" width="180"></el-table-column>
                    <el-table-column prop="name" label="联系人" align="center" width="120"></el-table-column>
                    <el-table-column prop="phone" label="手机号" align="center" width="130"></el-table-column>
                    <el-table-column label="详细地址" align="center" min-width="180">
                        <template #default="scope">
                            {{ (scope.row.areaNames || '') + (scope.row.addressDetail || '') }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderStatus" label="订单状态" align="center" width="100">
                        <template #default="scope">
                            {{ Options.wxOrderStatus.find(item => item.code === scope.row.orderStatus)?.enumCodeName || '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" align="center" width="180">
                        <template #default="scope">
                            {{ $formatTime(scope.row.createTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="150" fixed="right">
                        <template #default="scope">
                            <el-button type="primary" link @click="handleViewOrder(scope.row)">查看</el-button>
                            <el-button type="primary" link @click="handleEditOrder(scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                </template>

                <template #extra>
                    <el-dialog
                            v-model="orderDialogVisible"
                            :title="orderDialogType === 'view' ? '查看订单' : '修改订单'"
                            width="1000px"
                            destroy-on-close
                    >
                        <el-form
                                ref="orderFormRef"
                                :model="orderFormData"
                                :rules="orderFormRules"
                                label-width="100px"
                                class="list-modal-form"
                        >
                            <el-form-item label="订单号">
                                <el-input
                                        v-model="orderFormData.orderId"
                                        disabled
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="联系人">
                                <el-input
                                        v-model="orderFormData.name"
                                        disabled
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="手机号">
                                <el-input
                                        v-model="orderFormData.phone"
                                        disabled
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="省市区">
                                <el-input
                                        v-model="orderFormData.areaNames"
                                        disabled
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="详细地址">
                                <el-input
                                        v-model="orderFormData.addressDetail"
                                        disabled
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="物品描述">
                                <el-input
                                        v-model="orderFormData.items"
                                        disabled
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="预估总重量">
                                <el-input
                                        v-model="orderFormData.ygTotalWeight"
                                        disabled
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="预估总金额">
                                <el-input
                                        v-model="orderFormData.ygTotalAmount"
                                        disabled
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="订单状态" prop="orderStatus" v-if="orderDialogType === 'edit'">
                                <el-select
                                        v-model="orderFormData.orderStatus"
                                        placeholder="请选择"
                                        style="width: 100%;"
                                >
                                    <el-option
                                            v-for="item in Options.wxOrderStatus"
                                            :key="item.enumCodeName+item.code"
                                            :label="item.enumCodeName"
                                            :value="item.code"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注" prop="remark" v-if="orderDialogType === 'edit'">
                                <el-input
                                        v-model="orderFormData.remark"
                                        type="textarea"
                                        :rows="3"
                                        placeholder="请输入备注"
                                        style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="订单明细">
                                <el-table :data="orderItems" style="width: 100%;" border max-height="300">
                                    <el-table-column prop="itemName" label="物品名称" width="150"></el-table-column>
                                    <el-table-column prop="ygWeight" label="预估重量(kg)" width="120"></el-table-column>
                                    <el-table-column prop="price" label="单价(元/kg)" width="120"></el-table-column>
                                    <el-table-column prop="ygAmount" label="预估金额(元)" width="120"></el-table-column>
                                    <el-table-column prop="weight" label="实际重量(kg)" width="120"></el-table-column>
                                    <el-table-column prop="sjprice" label="实际单价(元/kg)" width="120"></el-table-column>
                                    <el-table-column prop="amount" label="实际金额(元)" width="120"></el-table-column>
                                </el-table>
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <div style="text-align: center; width: 100%;">
                                <el-button @click="orderDialogVisible = false">取消</el-button>
                                <el-button type="primary" @click="handleSubmitOrder" v-if="orderDialogType === 'edit'">确定</el-button>
                            </div>
                        </template>
                    </el-dialog>
                </template>
            </CommonList>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue'
    import useHomeIndex from './homeIndex.js'

    const listRef = ref(null)
    const orderListRef = ref(null)

    const {
        searchForm,
        orderSearchForm,
        orderItems,
        handleLoadList,
        handleLoadOrderList,
        handleReset,
        handleOrderReset,
        handleSelectionChange,
        handleCurrentRowChange,
        handleViewOrder,
        handleEditOrder,
        handleSubmitOrder,
        orderDialogVisible,
        orderDialogType,
        orderFormRef,
        orderFormData,
        orderFormRules,
        Options,
        getCheckStatusTagType,
        storageWarning,
        maskName,
        maskPlate,
        maskVin,
        maskPhone
    } = useHomeIndex(listRef, orderListRef)
</script>

<style scoped>
    @import '../../assets/css/util/base-list.css';

    .dashboard-page {
        padding: 24px;
        background: #f5f7fa;
        min-height: 100vh;
    }

    .card {
        background: #fff;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .todo-card {
        padding: 16px;
    }

    .todo-card :deep(.el-table) {
        font-size: 13px;
    }

    .todo-card :deep(.el-table th),
    .todo-card :deep(.el-table td) {
        padding: 8px 0;
    }

    .todo-card :deep(.common-search-item) {
        margin-bottom: 10px;
    }

    .card-title {
        font-size: 16px;
        font-weight: 600;
        color: #1e293b;
        margin: 0 0 12px 0;
    }
</style>
